import React from "react";

import auth from "../../services/authService";
import { COCKPIT_STORES_URL } from "../shared/constants";

function DeprecationNotice() {
  function logout() {
    if (auth.isAuthenticated()) {
      auth.logout();
    }
    // Remount the app so the unauthenticated branch sends the user back to the login page.
    window.location.reload();
  }

  return (
    <div className="flex items-center h-screen justify-center">
      <div className="bg-neutral-900 p-6 rounded-md text-center max-w-xl">
        <div className="text-xl">Manager is deprecated</div>
        <p className="mt-3 text-gray-300">
          This application is no longer maintained. Please use Cockpit instead, where all store management features are
          now available.
        </p>
        <a href={COCKPIT_STORES_URL}>
          <button type="button" className="bg-neutral-800 text-gray-200 p-2 rounded-md mt-4">
            Go to Cockpit
          </button>
        </a>
        <div>
          <button type="button" onClick={logout} className="text-gray-400 underline mt-4">
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DeprecationNotice);
